import type { Invoice } from '../../../api/server/models/Invoice';
import { parseLedgerAmount } from '../utils/statement-format.utils';

/** The one provider-entered discount an invoice can carry; posting again replaces it. */
export const PROVIDER_ADJUSTMENT_ITEM_ID = 'PROVIDER_ADJUSTMENT';

const toCents = (value: number): number => Math.round(value * 100);

/**
 * The provider's existing discount on an invoice, as a positive magnitude.
 *
 * Only PROVIDER_ADJUSTMENT counts. ENTER_ADJUSTMENT (system / support entered) is not the
 * provider's to change, so it stays inside the base amount.
 */
export const getProviderDiscount = (invoice?: Invoice): number => {
    const cents = (invoice?.items || [])
        .filter(item => item.itemId === PROVIDER_ADJUSTMENT_ITEM_ID)
        .reduce((sum, item) => sum + Math.abs(toCents(parseLedgerAmount(item.price?.amount))), 0);
    return cents / 100;
};

/**
 * The invoice total before the provider's discount. `invoice.amount` already has that discount
 * applied, so adding it back gives the base a new discount must be subtracted from.
 */
export const getBaseInvoiceAmount = (invoice?: Invoice): number =>
    (toCents(parseLedgerAmount(invoice?.amount?.amount)) + toCents(getProviderDiscount(invoice))) / 100;
